import { contractorsUi, operationUi } from '../text/ui'
import { meterUi } from '../text/ui/meter'
import { priceManagerUI } from '../text/ui/price'

export const QR_CODE = {
  LEVEL: 'M',
  SIZE: 60,
}

export const PriceManagerTableKey = {
  quantityLevel: 'quantity_level',
  supplyCost: 'supply_cost',
  lossCost: 'loss_cost',
  cost: 'cost',
  tariffCode: 'tariff_code',
  action: 'action',
  dailyDivision: 'daily_division',
}
export const getDailyDivision = (t: any) => {
  return [
    {
      label: t('priceManager.nomal'),
      value: 0,
    },
    {
      label: t('priceManager.monthProrated'),
      value: 1,
    },
    {
      label: t('priceManager.month2Prorated'),
      value: 2,
    },
  ]
}


export const dailyDivision = [
  {
    label: priceManagerUI.nomal,
    value: 0,
  },
  {
    label: priceManagerUI.monthProrated,
    value: 1,
  },
  {
    label: priceManagerUI.month2Prorated,
    value: 2,
  },
]

export const getDailyDivisionKey = (t: any) => ({
  0: t('priceManager.nomal'),
  1: t('priceManager.monthProrated'),
  2: t('priceManager.month2Prorated'),
})

export const getLanguageOptions = (t: any) => ([
  { value: LanguageEnum.JAPANESE, label: t('language.japanese') },
  { value: LanguageEnum.ENGLISH, label: t('language.english') }
])
export const dailyDivisionKey: { [key: number]: string } = {
  0: priceManagerUI.nomal,
  1: priceManagerUI.monthProrated,
  2: priceManagerUI.month2Prorated,
}

export const getTypeMeter = (t: any) => [
  { name: t('meter.water'), value: 1 },
  { name: t('meter.electric'), value: 2 },
  { name: t('meter.gas'), value: 3 },
]

export const typeMeter: { name: string; value: number }[] = [
  { name: meterUi.water, value: 1 },
  { name: meterUi.electric, value: 2 },
  { name: meterUi.gas, value: 3 },
]


export const getFLGType = (t: any) => ({
  0: t('contractors.flg_no_first'),
  1: t('contractors.flg_first'),
})

export const getFLGTypeKey = (t: any) => ({
  0: t('contractors.flg_no_first'),
  1: t('contractors.flg_first'),
})

export const FLGType: { [key: number]: string } = {
  0: contractorsUi.flg_no_first,
  1: contractorsUi.flg_first,
}

export const getMeterTypeKey = (t: any) => ({
  1: t('meter.water'),
  2: t('meter.electric'),
  3: t('meter.gas'),
})

export const meterTypeKey: { [key: number]: string } = {
  1: meterUi.water,
  2: meterUi.electric,
  3: meterUi.gas,
}


export const unit = {
  kw: 'KW',
  m3: 'm3',
  price: '円',
}

export const dataFormat = {
  yyyyMM: {
    ja: 'YYYY年MM月',
    en: 'YYYY/MM'
  },
  yyyyMMdd: {
    ja: 'YYYY年MM月DD日',
    en: 'YYYY/MM/DD'
  },
  yyyyMMEmpty: {
    ja: ' 年 月',
    en: ' / '
  },
  yyyyMMddEmpty: {
    ja: ' 年 月 日',
    en: ' / / '
  },
  YYYYMMDD: {
    ja: 'YYYY/MM/DD',
    en: 'YYYY/MM/DD'
  },
  yyyymm: {
    ja: 'YYYY/MM',
    en: 'YYYY/MM'
  },
  yyyyMMRange: {
    ja: 'YYYY年MM月～YYYY年MM月',
    en: 'YYYY/MM~YYYY/MM'
  }
}

export const getDateFormat = (format: keyof typeof dataFormat, lang: string = LanguageEnum.JAPANESE) => {
  return dataFormat[format][lang as keyof typeof dataFormat[typeof format]]
}


export const MAX_4_DEGIT_VALUE = 9999
export const MAX_5_DEGIT_VALUE = 99999
export const MAX_5_DEGIT_FLOAT_VALUE = 99999.99
export const MAX_6_DEGIT_FLOAT_VALUE = 999999.99
export const MAX_6_DEGIT_VALUE = 999999
export const MAX_11_DEGIT_VALUE = 99999999999

export const SIZE_5MB = 5 * 1024 * 1024

export const EXAMPLE_RESPONSE = {
  data: [],
  pagination: {
    current_page: 1,
    last_page: 1,
    per_page: 10,
    total: 0,
  },
}
export const PLATFORM_KEY: { [key: number]: string } = {
  1: 'platformWeb',
  2: 'platformApp',
}

export const PLATFORM: { [key: number]: string } = {
  1: operationUi.platformWeb,
  2: operationUi.platformApp,
}

export const OPERATION_TYPE_KEY: { [key: number]: string } = {
  1: 'typeLogin',
  2: 'typeRegister',
  3: 'typeUpdate',
  4: 'typeDelete',
  5: 'typeExport',
  6: 'typeDownload',
  7: 'logout',
}

export const OPERATION_TYPE: { [key: number]: string } = {
  1: operationUi.typeLogin,
  2: operationUi.typeRegister,
  3: operationUi.typeUpdate,
  4: operationUi.typeDelete,
  5: operationUi.typeExport,
  6: operationUi.typeDownload,
  7: operationUi.logout,
}

export const AUTHENTICATION_PASSCODE = 6

export const meterType: { label: string; value: number }[] = [
  { label: meterUi.water, value: 1 },
  { label: meterUi.electric, value: 2 },
  { label: meterUi.gas, value: 3 },
]
export const getRoundingType = (t: any) => {
  return [
    { label: t('priceManager.roundDown'), value: 0 },
    { label: t('priceManager.roundTo5'), value: 1 },
    { label: t('priceManager.roundUp'), value: 2 },
    { label: t('priceManager.roundTo6'), value: 3 },
  ]
}
export const roundingType: { label: string; value: number }[] = [
  { label: priceManagerUI.roundDown, value: 0 },
  { label: priceManagerUI.roundTo5, value: 1 },
  { label: priceManagerUI.roundUp, value: 2 },
  { label: priceManagerUI.roundTo6, value: 3 },
]

export const getRoundingUnit = (t: any) => {
  return [
    { label: t('priceManager.under1'), value: 0 },
    { label: t('priceManager.under10'), value: 1 },
    { label: t('priceManager.under100'), value: 2 },
    { label: t('priceManager.under1000'), value: 3 },
  ]
}
export const roundingUnit: { label: string; value: number }[] = [
  { label: priceManagerUI.under1, value: 0 },
  { label: priceManagerUI.under10, value: 1 },
  { label: priceManagerUI.under100, value: 2 },
  { label: priceManagerUI.under1000, value: 3 },
]

export const getMeterTypeFormula = (t: any) => {
  return [
    { label: t('meter.water'), value: 1 },
    { label: t('meter.another'), value: 0 }
  ]
}

export const meterTypeFormula: { label: string; value: number, }[] = [
  { label: meterUi.water, value: 1 },
  { label: meterUi.another, value: 0 }
]

export const MeterCategory = {
  Fiji: 1,
  Other: 2,
}

export enum LanguageEnum {
  // eslint-disable-next-line no-unused-vars
  ENGLISH = 'en',
  // eslint-disable-next-line no-unused-vars
  JAPANESE = 'ja',
}

export const monthArr = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]

export const monthNamesEn = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December'
]